import {
  MCP_SERVER_URL,
  claudeInstallUrl,
  cursorInstallUrl,
  vscodeInstallUrl,
} from "@/lib/mcp";

/** The AI tools the onboarding offers to set fastn up from, in the design's order. */
export type AiToolId = "claude" | "chatgpt" | "gemini" | "cursor" | "vscode" | "copilot";

/** What the signup question stores: a tool, "other", or "none" (none yet). */
export type AiToolAnswer = AiToolId | "other" | "none";

/** `domain` is where the logo comes from, through the api's favicon proxy. */
export const AI_TOOLS: Array<{ id: AiToolId; label: string; domain: string }> = [
  { id: "claude", label: "Claude", domain: "claude.ai" },
  { id: "chatgpt", label: "ChatGPT", domain: "chatgpt.com" },
  { id: "gemini", label: "Gemini", domain: "gemini.google.com" },
  { id: "cursor", label: "Cursor", domain: "cursor.com" },
  { id: "vscode", label: "VS Code", domain: "code.visualstudio.com" },
  { id: "copilot", label: "GitHub Copilot", domain: "github.com" },
];

/** The signup chips, which list Copilot before VS Code and end with Other / None yet. */
export const AI_TOOL_ANSWERS: Array<{ id: AiToolAnswer; label: string }> = [
  { id: "claude", label: "Claude" },
  { id: "chatgpt", label: "ChatGPT" },
  { id: "gemini", label: "Gemini" },
  { id: "cursor", label: "Cursor" },
  { id: "copilot", label: "GitHub Copilot" },
  { id: "vscode", label: "VS Code" },
  { id: "other", label: "Other" },
  { id: "none", label: "None yet" },
];

export function aiToolLabel(id: AiToolId): string {
  return AI_TOOLS.find((t) => t.id === id)?.label ?? "Claude";
}

/** The first tool they said they use, so every dropdown opens on it. Claude otherwise. */
export function defaultAiTool(answers: readonly string[] | undefined): { tool: AiToolId; fromAnswer: boolean } {
  const hit = (answers ?? []).find((a): a is AiToolId => AI_TOOLS.some((t) => t.id === a));
  return hit ? { tool: hit, fromAnswer: true } : { tool: "claude", fromAnswer: false };
}

/**
 * Where "Add to <tool>" goes. Claude, Cursor and VS Code take the server
 * prefilled; the rest have no install link, so they open on the tool and the
 * MCP link is copied for the person to paste into its connector settings.
 */
export function aiToolInstall(id: AiToolId, url: string = MCP_SERVER_URL): { href: string; copiesLink: boolean } {
  switch (id) {
    case "claude":
      return { href: claudeInstallUrl(url), copiesLink: false };
    case "cursor":
      return { href: cursorInstallUrl(url), copiesLink: false };
    case "vscode":
      return { href: vscodeInstallUrl(url), copiesLink: false };
    case "chatgpt":
      return { href: "https://chatgpt.com/", copiesLink: true };
    case "gemini":
      return { href: "https://gemini.google.com/", copiesLink: true };
    case "copilot":
      return { href: "https://github.com/copilot", copiesLink: true };
  }
}

/** The MCP link as the design shows it, without the scheme. */
export function mcpLinkLabel(url: string = MCP_SERVER_URL): string {
  return url.replace(/^https?:\/\//, "");
}
